// eslint-disable-next-line import/prefer-default-export
export enum JustifyType {
  CONTRACT_BILLING_DISABLE = 'CONTRACT_BILLING_DISABLE',
  CONTRACT_RULE_DISABLE = 'CONTRACT_RULE_DISABLE',
  CONTRACT_BILLING_DISCOUNT = 'CONTRACT_BILLING_DISCOUNT',
  CONTRACT_MARKED_EXPIRE = 'CONTRACT_MARKED_EXPIRE',
  INSTANCE_INTEGRATION_INACTIVATION = 'INSTANCE_INTEGRATION_INACTIVATION',
  CONTRACT_EXPIRATION_REVERSAL = 'CONTRACT_EXPIRATION_REVERSAL'
}
